import { Button } from "../../components/Shared/Button";

function BottomNav({
  onSave,
  onPreview,
}) {
  return (
    <div className="BottomNavContainer">
      <div className="BottomNav">
        <div className="BottomNavSave">
          <Button
            text="Save"
            onClick={onSave}
            color="white"
          />
        </div>
        <div className="BottomNavPreview">
          <Button
            text="Preview"
            onClick={onPreview}
          />
        </div>
      </div>
    </div>
  )
}

export { BottomNav }
